import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRouteSnapshot} from '@angular/router';
import {of} from 'rxjs';
import {tap} from 'rxjs/operators';

import {SalesForceData} from '@q9elements/ui-kit/common';
import {RefModelService} from '../../services/ref-model.service';

@Injectable()
export class RefModelMetaResolve {
  constructor(
    private refModelSvc: RefModelService,
    private titleService: Title
  ) {}

  resolve(route: ActivatedRouteSnapshot) {
    const refModelMeta = route.parent?.data.refModelMeta;
    if (refModelMeta) {
      return of(refModelMeta);
    }
    const refModelId = route.params['refModelId'] ?? route.parent?.params['refModelId'];
    return this.refModelSvc.fetchRefModelMeta(refModelId).pipe(
      tap((data: SalesForceData) => {
        if (data.external) {
          this.titleService.setTitle('Salesforce Org Model');
        } else {
          this.titleService.setTitle('Reference Model Editor');
        }
      })
    );
  }
}
